module.exports = __webpack_public_path__ + "static/media/button_itsuki134ba0b166807c4096456a582a77ca13.webp";